import React from 'react';
import styles from './Icon.module.scss';
import {
    FaTimes,
    FaBan,
    FaDollarSign,
    FaUserAstronaut,
    FaEdit,
    FaHome,
    FaIgloo,
    FaBoxOpen,
    FaLink,
    FaPlayCircle,
    FaTags,
    FaAt,
    FaPhone,
    FaUsers,
    FaBloggerB,
    FaTag,
    FaCheck,
    FaChevronRight,
    FaLinux,
    FaNpm,
    FaWindows,
    FaCubes,
    FaMobileAlt,
    FaArrowsAlt,
    FaShieldAlt,
    FaCloud,
    FaGripLines,
    FaGopuram,
    FaChevronUp,
    FaBolt,
    FaFingerprint,
    FaCreditCard,
    FaTh,
    FaLayerGroup,
    FaAngleDoubleUp,
    FaFortAwesome,
    FaQuestion,
    FaArrowDown,
    FaArrowRight,
    FaArrowLeft,
    FaRandom,
    FaCogs,
    FaKey,
    FaFileMedicalAlt,
    FaBook,
    FaCheckSquare,
    FaBug,
    FaRoute,
    FaSpaceShuttle,
    FaSatelliteDish,
    FaCode,
    FaDatabase,
    FaFileAlt,
    FaSearch,
    FaBell,
    FaMapMarkerAlt,
    FaAngleUp,
    FaForward,
    FaWifi,
    FaMeteor,
    FaTools,
    FaAppStore,
    FaAndroid,
    FaFirefoxBrowser,
    FaReact,
    FaMicrosoft,
    FaIdBadge,
    FaUserPlus,
    FaPlusCircle,
    FaUnlock,
    FaSignInAlt,
    FaTrafficLight,
    FaSyncAlt,
    FaUserCircle,
    FaReceipt,
    FaCashRegister,
    FaPowerOff,
    FaUndo,
    FaBinoculars,
    FaRoad,
    FaPaperPlane,
    FaPlusSquare,
    FaBrain,
    FaThLarge,
    FaShareAlt,
    FaRegCompass,
    FaGithub,
    FaLinkedin,
    FaThumbsUp,
    FaTimesCircle,
    FaServer,
    FaHeartbeat,
    FaChartLine,
    FaEye,
    FaDocker,
    FaCircle,
    FaTerminal,
    FaMouse,
    FaCodeBranch,
    FaTrash,
    FaCircleNotch,
    FaChevronDown,
    FaCross,
    FaPause,
    FaAnchor

} from 'react-icons/fa';
import { IconContext } from "react-icons";

const Icon = (props) => {

    let component = <FaHome />;
    switch (props.name) {
        case 'person-minus':
            component = <FaTimes />
            break;
        case 'anchor':
            component = <FaAnchor />
            break;
        case 'cross':
            component = <FaCross />
            break;
        case 'circle-notch':
            component = <FaCircleNotch />
            break;
        case 'at':
            component = <FaAt />
            break;
        case 'pause':
            component = <FaPause />
            break;
        case 'codeBranch':
            component = <FaCodeBranch />
            break;
        case 'mouse':
            component = <FaMouse />
            break;
        case 'terminal':
            component = <FaTerminal />
            break;
        case 'circle':
            component = <FaCircle />
            break;
        case 'docker':
            component = <FaDocker />
            break;
        case 'times-circle':
            component = <FaTimesCircle />
            break;
        case 'eye':
            component = <FaEye />
            break;
        case 'chart-line':
            component = <FaChartLine />
            break;
        case 'check':
            component = <FaCheck />
            break;
        case 'cloud-arrow-up':
            component = <FaCloud />
            break;
        case 'heart-beat':
            component = <FaHeartbeat />
            break;
        case 'server':
            component = <FaServer />
            break;
        case 'thumbs-up':
            component = <FaThumbsUp />;
            break;
        case 'dollar-sign':
            component = <FaDollarSign />;
            break;
        case 'developers':
            component = <FaUserAstronaut />
            break;
        case 'times':
            component = <FaTimes />
            break;
        case 'edit':
            component = <FaEdit />
            break;
        case 'linkedin':
            component = <FaLinkedin />
            break;
        case 'github':
            component = <FaGithub />
            break;
        case 'box-open':
            component = <FaBoxOpen />
            break;
        case 'share-alt':
            component = <FaShareAlt />
            break;
        case 'th-large':
            component = <FaThLarge />
            break;
        case 'cogs':
            component = <FaCogs />
            break;
        case 'brain':
            component = <FaBrain />
            break;
        case 'plus-square':
            component = <FaPlusSquare />
            break;
        case 'plus-circle':
            component = <FaPlusCircle />
            break;
        case 'paper-plane':
            component = <FaPaperPlane />;
            break;
        case 'road':
            component = <FaRoad />;
            break;
        case 'binoculars':
            component = <FaBinoculars />;
            break;
        case 'undo':
            component = <FaUndo />;
            break;
        case 'power-off':
            component = <FaPowerOff />;
            break;
        case 'cash-register':
            component = <FaCashRegister />;
            break;
        case 'receipt':
            component = <FaReceipt />;
            break;
        case 'user-circle':
            component = <FaUserCircle />;
            break;
        case 'sync-alt':
            component = <FaSyncAlt />;
            break;
        case 'credit-card':
            component = <FaCreditCard />;
            break;
        case 'traffic-light':
            component = <FaTrafficLight />;
            break;
        case 'trash-icon':
            component = <FaTrash />;
            break;
        case 'sign-in-alt':
            component = <FaSignInAlt />;
            break;
        case 'unlock':
            component = <FaUnlock />;
            break;
        case 'home':
            component = <FaIgloo />;
            break;
        case 'link':
            component = <FaLink />;
            break;
        case 'play':
            component = <FaPlayCircle />;
            break;
        case 'tags':
            component = <FaTags />;
            break;
        case 'phone':
            component = <FaPhone />;
            break;
        case 'users':
            component = <FaUsers />;
            break;
        case 'blog':
            component = <FaBloggerB />;
            break;
        case 'tag':
            component = <FaTag />;
            break;
        case 'chevron-right':
            component = <FaChevronRight />;
            break;
        case 'linux':
            component = <FaLinux />;
            break;
        case 'npm':
            component = <FaNpm />;
            break;
        case 'windows':
            component = <FaWindows />;
            break;
        case 'cubes':
            component = <FaCubes />;
            break;
        case 'arrows-alt':
            component = <FaArrowsAlt />
            break;
        case 'mobile':
            component = <FaMobileAlt />;
            break;
        case 'shield-alt':
            component = <FaShieldAlt />
            break;
        case 'cloud':
            component = <FaCloud />
            break;
        case 'shield':
            component = <FaShieldAlt />
            break;
        case 'grip-lines':
            component = <FaGripLines />
            break;
        case 'gopuram':
            component = <FaGopuram />
            break;
        case 'chevron-up':
            component = <FaChevronUp />
            break;
        case 'chevron-down':
            component = <FaChevronDown />
            break;
        case 'angle-double-up':
            component = <FaAngleDoubleUp />
            break;
        case 'bolt':
            component = <FaBolt />
            break;
        case 'fingerprint':
            component = <FaFingerprint />
            break;
        case 'th':
            component = <FaTh />
            break;
        case 'fort-awesome':
            component = <FaFortAwesome />
            break;
        case 'question':
            component = <FaQuestion />
            break;
        case 'arrow-down':
            component = <FaArrowDown />
            break;
        case 'arrow-right':
            component = <FaArrowRight />
            break;
        case 'arrow-left':
            component = <FaArrowLeft />
            break;
        case 'random':
            component = <FaRandom />
            break;
        case 'key':
            component = <FaKey />
            break;
        case 'file-medical-alt':
            component = <FaFileMedicalAlt />
            break;
        case 'book':
            component = <FaBook />
            break;
        case 'ban':
            component = <FaBan />
            break;
        case 'check-square':
            component = <FaCheckSquare />
            break;
        case 'bug':
            component = <FaBug />
            break;
        case 'route':
            component = <FaRoute />
            break;
        case 'space-shuttle':
            component = <FaSpaceShuttle />
            break;
        case 'satellite-dish':
            component = <FaSatelliteDish />
            break;
        case 'code':
            component = <FaCode />
            break;
        case 'database':
            component = <FaDatabase />
            break;
        case 'file-alt':
            component = <FaFileAlt />
            break;
        case 'search':
            component = <FaSearch />
            break;
        case 'compass':
            component = <FaRegCompass />
            break;
        case 'mobile-alt':
            component = <FaMobileAlt />
            break;
        case 'bell':
            component = <FaBell />
            break;
        case 'map-marker-alt':
            component = <FaMapMarkerAlt />
            break;
        case 'layer-group':
            component = <FaLayerGroup />
            break;
        case 'angle-up':
            component = <FaAngleUp />
            break;
        case 'forward':
            component = <FaForward />
            break;
        case 'wifi':
            component = <FaWifi />
            break;
        case 'meteor':
            component = <FaMeteor />
            break;
        case 'tools':
            component = <FaTools />
            break;
        case 'app-store':
            component = <FaAppStore />
            break;
        case 'android':
            component = <FaAndroid />
            break;
        case 'firefox-browser':
            component = <FaFirefoxBrowser />
            break;
        case 'react':
            component = <FaReact />
            break;
        case 'microsoft':
            component = <FaMicrosoft />
            break;
        case 'id-badge':
            component = <FaIdBadge />
            break;
        case 'user-plus':
            component = <FaUserPlus />
            break;
        default:
            component = null;
    }

    return (
        <span onClick={props.onClick} {...props} className={styles.Icon}>
            <IconContext.Provider
                value={{
                    color: props.color,
                    size: props.size,
                    className: props.className,
                    onClick: props.onClick
                }}
            >
                {component}{props.text && <span style={{ margin: '0 0 0 5px' }}>{props.text}</span>}
            </IconContext.Provider>
        </span>
    );
}

export default Icon;